import React from "react";
import { INGRID_SUPPORT_EMAIL } from "rylak-common/src/constants";

export default function TurnrSupportEmail() {
    return <a href={`mailto:${INGRID_SUPPORT_EMAIL}`}>{INGRID_SUPPORT_EMAIL}</a>;
}
